<script>
import Axios from 'axios';
import GoogleLocation from './utility/google-location';
import SupplierMakes from './utility/supplier-makes';
import Multiselect from 'vue-multiselect';
import _ from 'lodash';
import Email from './utility/email-validator';
import {mapGetters} from 'vuex';

export default {
    name: 'suppliers-new',
    data: function () {
        return {
            vehicleOwnersStatus: true,
            selectedMake: '',
            isCheckedSuppEmail: true,
            supplier: {
                id: 0,
                business_name: '',
                abn: '',
                type: '',
                businessType: '',
                dms: '',
                phone: '',
                fax: '',
                email: '',
                address: '',
                street_name: '',
                level_unit_lot: '',
                suburb: '',
                state: '',
                postcode: '',
                country: '',
                makes: [],
                contacts: [],
                warehouses: [],
            },
            optionSupplyKind: {},
            optiontype: {},
            optionstate: {},
            optioncountry: {},
            optiontypevalues: [
                {name: 'Parts', value: 'parts'},
                {name: 'Consumables', value: 'consumables'},
                {name: 'Mechanical', value: 'mechanical'},
                {name: 'PDR', value: 'pdr'},
                {name: 'Ancilary Services', value: 'ancillary'},
            ],
            optionstatevalues: [
                {name: 'Queensland', value: 'QLD'},
                {name: 'Northern Territory', value: 'NT'},
                {name: 'New South Wales', value: 'NSW'},
                {name: 'Victoria', value: 'VIC'},
                {name: 'Tasmania', value: 'TAS'},
                {name: 'South Australia', value: 'SA'},
                {name: 'Western Australia', value: 'WA'},
            ],
            optioncountryvalues: [
                {name: 'Australia', value: 'AU'},
                {name: 'New Zealand', value: 'NZ'},
            ],
            activeTab: 'details',
        };
    },
    computed: {
        ...mapGetters({
            isCustomerUser: 'isCustomerUser',
            isEstimatorUser: 'isEstimatorUser',
            isStatusActive: 'isStatusActive',    getterBusinessName : 'getBusinessName',
              isShowBusinessName: 'isShowBusinessName',
            }),
          selectionSupplyKind() {
            if (this.optiontype.value == 'parts') {
                this.optionSupplyKind = {};
                return [{name: 'OEM', value: 'OEM'}, {name: 'PARALLEL', value: 'PARALLEL'}, {name: 'AFTERMARKET', value: 'AFTERMARKET'}, {name: 'USED', value: 'USED'}, {name: 'RECO', value: 'RECO'}];
            }
            if (this.optiontype.value == 'consumables') {
                this.optionSupplyKind = {};
                return [{name: 'PAINT', value: 'PAINT'}, {name: 'WORKSHOP Materials', value: 'WM'}, {name: 'BOTH', value: 'BOTH'}];
            }
            return [];
        },
        vehicleMakeModels: {
            get: function () {
                return this.$store.state.vehicleMakeModels;
            },
            set: function (obj) {
            },
        },
        vehicleMakes: function () {
            try {
                var _result = [];
                _.forEach(this.vehicleMakeModels, function (value, key) {
                    _result.push(key);
                });
                return _.sortBy(_result);
            } catch (erro) {
                console.log(erro);
                return [];
            }
        },
    },
    watch: {
        selectedMake: function (newVal, oldValue) {
            if (oldValue && newVal === null) {
                let index = this.supplier.makes.indexOf(oldValue);
                this.supplier.makes.splice(index, 1);
                return;
            }
            if (!newVal) {
                return;
            }
            if (this.supplier.makes.includes(newVal)) {
                return;
            }
            this.supplier.makes.push(newVal);
        },
    },
    methods: {
        chooseTypeTab(tab) {
            this.activeTab = tab;
        },
        removeChip(chip) {
            if (this.selectedMake === chip) {
                this.selectedMake = '';
            }
        },
        saveData: function () {
            if (!this.isCheckedSuppEmail) {
                toastr.error('Your changes could not be saved, please check the form fields again');
                return;
            }
            if (this.optiontype) {
                this.supplier.businessType = this.optiontype.value;
            }
            if (this.optionSupplyKind) {
                this.supplier.type = this.optionSupplyKind.value;
            }
            if (this.optionstate) {
                this.supplier.state = this.optionstate.value;
            }
            if (this.optioncountry) {
                this.supplier.country = this.optioncountry.value;
            }
            NProgress.start();
            Axios({
                method: 'post',
                responseType: 'json',
                url: '/fe/supplier',
                validateStatus: function (status) {
                    return status < 500;
                },
                data: JSON.stringify(this.supplier)
            })
                .then(response => {
                    if (response.status == 200) {
                        toastr.success('Supplier details saved');
                        let supplierId = _.get(response, 'data.supplier.supplier_id') || _.get(response, 'data.supplier.id') || _.get(response, 'data.supplier_id') || _.get(response, 'data.id');
                        if (supplierId) {
                            this.$router.push('/suppliers/view/' + supplierId);
                        } else {
                            this.$router.push('/suppliers');
                        }
                    } else {
                        toastr.error(response.data.msg);
                    }
                })
                .catch(error => {
                    toastr.error(error);
                })
                .finally(() => {
                    NProgress.done();
                });
        },
        addressChanged: function (addr) {
            this.supplier.address = addr['address'];
            this.supplier.level_unit_lot = addr['levelUnitLot'];
            this.supplier.street_name = addr['street_name'];
            this.supplier.suburb = addr['suburb'];
            this.supplier.state = addr['state'];
            this.optionstate = this.optionstatevalues.find(item => item.value == this.supplier.state);
            this.supplier.postcode = addr['postcode'];
            this.supplier.country = addr['country'];
            this.optioncountry = this.optioncountryvalues.find(item => item.value == this.supplier.country);
        },
    },
    components: {
        GoogleLocation,
        Multiselect,
        SupplierMakes,
        Email,
    }
};
</script>

<template>
    <div class="suppliers-edit-page suppliers-new-page">
        <div class="page-header">
            <h4>New Supplier</h4>
            <ol class="breadcrumbs">
                <li class="breadcrumb-item home">
                    <router-link to="/">Home</router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link to="/suppliers">View Suppliers</router-link>
                </li>
                <li class="breadcrumb-item active">New Supplier</li>
            </ol>
            <h4 v-if="isShowBusinessName" class="header-display-name">{{ getterBusinessName }}</h4>
        </div>
        <div class="box box-block bg-white">
            <div class="tabs-component">
                <ul class="nav nav-tabs nav-tabs-2 float-sm-left">
                    <li class="tabs-component-tab nav-item">
                        <a class="nav-link" :class="{active: activeTab === 'details'}" data-toggle="tab" href="#details" @click="chooseTypeTab('details')">Details</a>
                    </li>
                    <li class="tabs-component-tab nav-item">
                        <a class="nav-link disabled" :class="{active: activeTab === 'contacts'}" href="#contacts" @click.prevent="chooseTypeTab('contacts')">Contacts</a>
                    </li>
                    <li class="tabs-component-tab nav-item">
                        <a class="nav-link disabled" :class="{active: activeTab === 'locations'}" href="#locations" @click.prevent="chooseTypeTab('locations')">Locations</a>
                    </li>
                </ul>
                <div class="rs-btn-group tab-header float-sm-right">
                    <div v-if="activeTab === 'details' && !isCustomerUser && isStatusActive" class="tabs-nav-right-btn tabs-nav-right-btn-position">
                        <button @click="saveData" type="button" class="btn btn-primary plus-btn-hover">Save</button>
                    </div>
                </div>
            </div>
            <div class="card main-card">
                <div class="card-block tab-content tables_bottom">
                    <div id="details" class="card-block tab-pane p-0" :class="{active: activeTab === 'details'}">
                        <div class="row">
                            <div class="col-md-6 pl-0">
                                <div class="card">
                                    <div class="card-header bg-navyblue">
                                        <strong>Vehicle Owners</strong>
                                    </div>
                                    <div class="card-block bg-white">
                                        <div class="card-block bg-white">
                                            <label class="col-lg-3 col-form-label" style="padding-left: 0px;">Status</label>
                                            <toggle-button
                                                v-model="vehicleOwnersStatus"
                                                class="mb-0 rs-toggle__button"
                                                color="#5E79FF"
                                                :width="40"
                                                :disabled="!isStatusActive"
                                                :sync="true"
                                                :labels="false"/>
                                            <span class="form-text text-active d-inline-block col-form-label mt-0 ml-0-25">
                                                <template v-if="vehicleOwnersStatus">Active</template>
                                                <template v-else>Not Active</template>
                                            </span>
                                        </div>
                                        <div class="form-group row">
                                            <label for="type" class="col-lg-3 col-form-label">Business Type</label>
                                            <div class="col-lg-9">
                                                <multiselect v-model="optiontype" :options="optiontypevalues"
                                                             :searchable="false"
                                                             :close-on-select="true"
                                                             :show-labels="false"
                                                             :disabled="isCustomerUser || !isStatusActive"
                                                             style="opacity: 1; height: 32px"
                                                             :class="{'customer-service-disabled': isCustomerUser}"
                                                             track-by="value"
                                                             label="name"
                                                             id="type">
                                                </multiselect>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="business_name" class="col-lg-3 col-form-label">Name</label>
                                            <div class="col-lg-9">
                                                <input :readonly="!isStatusActive" :disabled="isCustomerUser" type="text" v-model="supplier.business_name" :class="{'customer-service-disabled': isCustomerUser}" class="form-control" id="business_name" placeholder="Business Name">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="abn" class="col-lg-3 col-form-label">ABN</label>
                                            <div class="col-lg-9">
                                                <input :readonly="!isStatusActive" :disabled="isCustomerUser" type="text" v-model="supplier.abn" :class="{'customer-service-disabled': isCustomerUser}" class="form-control" id="abn" placeholder="ABN">
                                            </div>
                                        </div>
                                        <div v-if="optiontype.value === 'parts' || optiontype.value === 'consumables'" class="form-group row">
                                            <label for="type" class="col-lg-3 col-form-label">Supply Kind</label>
                                            <div class="col-lg-9">
                                                <multiselect v-model="optionSupplyKind"
                                                             :options="selectionSupplyKind"
                                                             :close-on-select="true"
                                                             :showLabels="false"
                                                             :disabled="isCustomerUser || !isStatusActive"
                                                             style="opacity: 1; height: 32px"
                                                             :class="{'customer-service-disabled': isCustomerUser}"
                                                             track-by="value"
                                                             label="name"
                                                             :max-height="203">
                                                </multiselect>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="dms" class="col-lg-3 col-form-label">DMS</label>
                                            <div class="col-lg-9">
                                                <input :readonly="!isStatusActive" :disabled="isCustomerUser" type="text" v-model="supplier.dms" :class="{'customer-service-disabled': isCustomerUser}" class="form-control" id="dms" placeholder="DMS">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="phone" class="col-lg-3 col-form-label">Phone</label>
                                            <div class="col-lg-9">
                                                <input :readonly="!isStatusActive" :disabled="isCustomerUser" type="text" v-model="supplier.phone" :class="{'customer-service-disabled': isCustomerUser}" class="form-control" id="phone" placeholder="Phone">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="fax" class="col-lg-3 col-form-label">Fax</label>
                                            <div class="col-lg-9">
                                                <input :readonly="!isStatusActive" :disabled="isCustomerUser" type="text" v-model="supplier.fax" :class="{'customer-service-disabled': isCustomerUser}" class="form-control" id="fax" placeholder="Fax">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="email" class="col-lg-3 col-form-label">Email</label>
                                            <email
                                                :email="supplier.email"
                                                :is-disabled="isCustomerUser || !isStatusActive"
                                                @onChange="(value) => supplier.email = value"
                                                @checked="(value) => isCheckedSuppEmail = value"
                                                class="col-lg-9">
                                            </email>
                                        </div>
                                        <div class="form-group row">
                                            <label for="address" class="col-lg-3 col-form-label">Search Address</label>
                                            <div class="col-lg-9">
                                                <google-location type="text" :refsAddress="'defaultForm'" v-model="supplier.address" id="address"
                                                                 placeholder="Search for an Address"
                                                                 :isDisabled="isCustomerUser || !isStatusActive"
                                                                 :class="{'customer-service-disabled': isCustomerUser}"
                                                                 @onPlaceChange="addressChanged"></google-location>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="level_unit_lot" class="col-lg-3 col-form-label">Level/Unit/Lot Nbr</label>
                                            <div class="col-lg-9">
                                                <input :disabled="isCustomerUser" type="text" v-model="supplier.level_unit_lot" :class="{'customer-service-disabled': isCustomerUser}" class="form-control" id="level_unit_lot" placeholder="Lot, Unit, or Level number">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="street_name" class="col-lg-3 col-form-label">Street Name</label>
                                            <div class="col-lg-9">
                                                <input :readonly="!isStatusActive" :disabled="isCustomerUser" type="text" v-model="supplier.street_name" :class="{'customer-service-disabled': isCustomerUser}" class="form-control" id="street_name" placeholder="Street Name">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="suburb" class="col-lg-3 col-form-label">Suburb</label>
                                            <div class="col-lg-9">
                                                <input :readonly="!isStatusActive" :disabled="isCustomerUser" type="text" v-model="supplier.suburb" :class="{'customer-service-disabled': isCustomerUser}" class="form-control" id="suburb" placeholder="Suburb">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="state" class="col-lg-3 col-form-label">State</label>
                                            <div class="col-lg-9">
                                                <multiselect v-model="optionstate"
                                                             :options="optionstatevalues"
                                                             :searchable="false"
                                                             :close-on-select="true"
                                                             :disabled="isCustomerUser || !isStatusActive"
                                                             style="opacity: 1"
                                                             :class="{'customer-service-disabled': isCustomerUser}"
                                                             :show-labels="false"
                                                             track-by="value"
                                                             label="name">
                                                </multiselect>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="postcode" class="col-lg-3 col-form-label">Postcode</label>
                                            <div class="col-lg-9">
                                                <input :readonly="!isStatusActive" :disabled="isCustomerUser" type="text" v-model="supplier.postcode" :class="{'customer-service-disabled': isCustomerUser}" class="form-control" id="postcode" placeholder="Postcode">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="country" class="col-lg-3 col-form-label">Country</label>
                                            <div class="col-lg-9">
                                                <multiselect v-model="optioncountry" :options="optioncountryvalues"
                                                             :searchable="false"
                                                             :close-on-select="true"
                                                             :show-labels="false"
                                                             :disabled="isCustomerUser || !isStatusActive"
                                                             style="opacity: 1"
                                                             :class="{'customer-service-disabled': isCustomerUser}"
                                                             track-by="value"
                                                             label="name">
                                                </multiselect>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 pr-0">
                                <div class="card">
                                    <div class="card-header bg-navyblue suplier-mobile-block">
                                        <strong>Supplier Brands</strong>
                                    </div>
                                    <div class="card-block bg-white">
                                        <div class="form-group row">
                                            <label class="col-lg-4 col-form-label">Search and add Makes of Cars supplied</label>
                                            <div class="col-lg-8">
                                                <multiselect
                                                    v-model="selectedMake"
                                                    :options="vehicleMakes"
                                                    :multiple="false"
                                                    :close-on-select="true"
                                                    :clear-on-select="true"
                                                    :disabled="isCustomerUser || !isStatusActive"
                                                    style="opacity: 1"
                                                    :class="{'customer-service-disabled': isCustomerUser}"
                                                    :preserve-search="true"
                                                    placeholder="Type to search and add a make"
                                                    :preselect-first="false">
                                                    <template v-slot:cell(selection)="{ values, search, isOpen }"></template>
                                                </multiselect>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-lg-4 col-form-label">Makes of Parts Supplied</label>
                                            <div class="col-lg-8">
                                                <supplier-makes @removeChip="removeChip" :chips="supplier.makes"></supplier-makes>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 pr-0">
                                <div class="card">
                                    <div class="card-header bg-navyblue suplier-mobile-block">
                                        <strong>Account</strong>
                                    </div>
                                    <div class="card-block bg-white">
                                        <div class="form-group row">
                                            <label for="account_type" class="col-lg-3 col-form-label">Account Type</label>
                                            <div class="col-lg-9">
                                                <input :disabled="isCustomerUser" type="text" :class="{'customer-service-disabled': isCustomerUser}" class="form-control" id="account_type" placeholder="Cash / COD">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label for="tax_code" class="col-lg-3 col-form-label">Tax Code</label>
                                            <div class="col-lg-9">
                                                <input :readonly="!isStatusActive" :disabled="isCustomerUser" type="text" :class="{'customer-service-disabled': isCustomerUser}" class="form-control" id="tax_code">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="contacts" class="tab-pane p-0" :class="{active: activeTab === 'contacts'}">
                        <div class="table_head">
                            <p>Contacts</p>
                        </div>
                        <div class="empty-new-supplier-tab">Save supplier details first to add contacts.</div>
                    </div>
                    <div id="locations" class="tab-pane p-0" :class="{active: activeTab === 'locations'}">
                        <div class="table_head">
                            <p>Warehouse Locations</p>
                        </div>
                        <div class="empty-new-supplier-tab">Save supplier details first to add warehouse locations.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .tables_bottom table thead th {
        background-color: #E7E8EC !important;
        color: #373A3C !important;
        font-weight: 400;
    }
</style>
<style scoped>
    .card-header {
        border-bottom-color: #EEEEEE !important;
        background-color: white !important;
        height: unset;
    }

    @media (max-width: 767px) {
        .overflow-x-xs {
            overflow-x: auto;
        }

        .pl-0 {
            padding-right: 0;
        }

        .pr-0 {
            padding-left: 0;
        }
    }

    .table_head {
        background-color: rgb(239, 238, 241);
        margin-bottom: 3px;
        border-radius: 5px 5px 0px 0px;
        height: 50px;
    }

    .table_head > p {
        margin-bottom: 0;
        color: black;
        padding: 14px;
        font-weight: bold;
        font-size: 15px;
    }

    .rs-btn-group {
        padding-top: 8px;
        display: flex;
        justify-content: flex-end;
        padding-right: 10px;
    }

    .empty-new-supplier-tab {
        padding: 24px;
        color: #6C757D;
        background-color: #FFFFFF;
        border: 1px solid #EEEEEE;
    }
</style>
